<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-800">
          <div class="modal-header">
            <slot name="header"> New Password </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-2">
                  <label for="password"> Password: </label>
                </div>
                <div class="col-9">
                  <input
                    type="password"
                    class="form-control"
                    id="new_password"
                    ref="personnel_new_password"
                    placeholder=" enter your password"
                    v-model="new_password"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-2">
                  <label for="password"> Confirm Password: </label>
                </div>
                <div class="col-9">
                  <input
                    type="password"
                    class="form-control"
                    id="confirm_password"
                    ref="personnel_confirm_password"
                    placeholder="confirm your password"
                    v-model="confirm_password"
                  />
                </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NewPasswordModal",
  data: () => ({  // reactive data
    new_password: "",
    confirm_password: "",
  }),
  props: {
    personnel: {
      type: Object,
      default: null,
    },
  },

  methods: {
    ...mapActions("personnels", ["apiCreatePassword"]), //personnels.js

    _save() {
      if (!this.$refs.personnel_new_password.value) 
      {
        alert("please enter a password");
        return;
      }

      if (
        this.$refs.personnel_new_password.value !=
        this.$refs.personnel_confirm_password.value
      ) {
        alert("passwords are not the same");
        return;
      }

      var password = 
      {
        id: this.personnel.id,
        new_password: this.$refs.personnel_new_password.value,
        confirm_password: this.$refs.personnel_confirm_password.value,
      };

      this.apiCreatePassword(password);
      this.$emit("close");
    },

    getPassword() {
      if (this.personnel == null) 
      {
        return "";
      } else {
        return this.personnel_new_password;
      }
    },

    clear() 
    {
      this.new_password = "";
      this.confirm_password = "";
    },
  },
  components: {},
};
</script>
